import { EsimInformationMetaBlock, EsimPackage } from "@/lib/redux/features/esim/types";

/** `informationMeta` is raw partner data per language — fall back to whichever language is present. */
export const getEsimInformationMeta = (
  pkg: EsimPackage | null | undefined,
  lang: string,
): EsimInformationMetaBlock => {
  const key = lang?.toLowerCase().startsWith("en") ? "en" : "vi";
  return (
    pkg?.informationMeta?.[key] ?? pkg?.informationMeta?.vi ?? pkg?.informationMeta?.en ?? {}
  );
};
